"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var error_panel_1 = require("../../../../components/pricing/layout/error-panel/error-panel");

var page_buttons_1 = require("../../../../components/pricing/layout/page-buttons/page-buttons");

var page_connected_1 = require("../../../../components/pricing/layout/page/page.connected");

var static_text_1 = require("../../../../components/pricing/text/static-text/static-text");

var error_context_1 = require("../../../../theming/pricing-system/error-context");

var login_page_content_1 = require("../../../../theming/pricing-system/login-page.content");

var loginContentViewStyle = {
  marginBottom: '1rem',
  marginTop: '1rem'
};
var errorPanelViewStyle = {
  left: 0,
  position: 'relative',
  top: 0
};
var paragraphTextStyle = {
  marginBottom: '1em'
};
var supportedBrowsersTextStyle = {
  fontWeight: 'bold'
};

var LoginPage = function (_super) {
  __extends(LoginPage, _super);

  function LoginPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.login = function () {
      if (_this.props.login) {
        _this.props.login(_this);
      }
    };

    _this.logout = function () {
      if (_this.props.logout) {
        _this.props.logout(_this);
      }
    };

    return _this;
  }

  LoginPage.prototype.componentDidMount = function () {
    if (this.doAutomaticLogin) {
      this.login();
    }
  };

  LoginPage.prototype.render = function () {
    if (this.doAutomaticLogin) {
      return null;
    }

    return react_1.default.createElement(page_connected_1.PageConnected, {
      title: login_page_content_1.LoginPageContent.title,
      notification: this.notificationContent
    }, this.renderContent(), this.renderPageButtons());
  };

  LoginPage.prototype.getUserAgent = function () {
    return navigator.userAgent;
  };

  Object.defineProperty(LoginPage.prototype, "doAutomaticLogin", {
    get: function get() {
      return !!this.props.doAutomaticLogin && !this.props.isLogoutRequired;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(LoginPage.prototype, "notificationContent", {
    get: function get() {
      if (this.isBrowserSupported()) {
        return null;
      }

      var title = login_page_content_1.LoginPageContent.supportedBrowsersTitle + " ";
      return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(react_native_1.Text, {
        style: supportedBrowsersTextStyle
      }, title), react_1.default.createElement(react_native_1.Text, null, login_page_content_1.LoginPageContent.supportedBrowsersList));
    },
    enumerable: true,
    configurable: true
  });

  LoginPage.prototype.isBrowserSupported = function () {
    var userAgent = this.getUserAgent().toLowerCase();
    return userAgent.indexOf('chrome') !== -1 || userAgent.indexOf('safari') !== -1;
  };

  LoginPage.prototype.renderContent = function () {
    if (this.props.isLogoutRequired) {
      return this.renderLoginIncompleteError();
    }

    return this.renderLoginContent();
  };

  LoginPage.prototype.renderLoginContent = function () {
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(react_native_1.View, {
      style: loginContentViewStyle
    }, react_1.default.createElement(static_text_1.StaticText, {
      text: login_page_content_1.LoginPageContent.instructions
    })));
  };

  LoginPage.prototype.renderLoginIncompleteError = function () {
    var accountName = this.props.accountName || '';
    var errorContent = react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(static_text_1.StaticText, {
      text: login_page_content_1.LoginPageContent.incompleteLoginMessage(accountName),
      textStyle: paragraphTextStyle
    }), react_1.default.createElement(static_text_1.StaticText, {
      text: login_page_content_1.LoginPageContent.incorrectAccountInstructions,
      textStyle: paragraphTextStyle
    }), react_1.default.createElement(static_text_1.StaticText, {
      text: login_page_content_1.LoginPageContent.correctAccountInstructions,
      textStyle: paragraphTextStyle
    }));
    return react_1.default.createElement(error_panel_1.ErrorPanel, {
      contextId: error_context_1.ErrorContext.login,
      heading: login_page_content_1.LoginPageContent.incompleteLoginErrorHeading,
      message: errorContent,
      viewStyle: errorPanelViewStyle
    });
  };

  LoginPage.prototype.renderPageButtons = function () {
    var loginButtons = [{
      onPress: this.login,
      text: login_page_content_1.LoginPageContent.signinButtonText
    }];
    var logoutButtons = [{
      onPress: this.logout,
      text: login_page_content_1.LoginPageContent.signoutButtonText
    }];
    var buttons = this.props.isLogoutRequired ? logoutButtons : loginButtons;
    return react_1.default.createElement(page_buttons_1.PageButtons, {
      buttons: buttons
    });
  };

  return LoginPage;
}(react_1.default.Component);

exports.LoginPage = LoginPage;